import React from 'react';
import { NEW_EU_HELP_ROUTER_ATTRIBUTES } from '../../../support/support-constants';

interface NewEuHelpRouterProps {
    currentLanguageRegionCode: string;
}

export const NewEuHelpRouter = (props: NewEuHelpRouterProps) => {
    const { currentLanguageRegionCode } = props;
    const getChatBotAemUrl = (languageRegionCode: string) => {
        const fordMarkets = NEW_EU_HELP_ROUTER_ATTRIBUTES.ford.supportedMarkets;
        return fordMarkets.find(
            market => market.languageRegionCode === languageRegionCode
        )?.chatbotConfigUrl;
    };

    return (
        <>
            <div
                className="host-container dse-chatbot"
                data-json-path={getChatBotAemUrl(currentLanguageRegionCode)}
                data-is-author-edit-mode="false"
            />
        </>
    );
};
